import React, { useEffect, useState } from 'react'
import FishingLicenceInformationView from './components/FishingLicenceInformationView'
import Error from 'shared/components/Error'
import { withTranslation } from 'react-i18next'
import { addToGoogleDataLayer } from 'shared/const/utls.js'

const FishingLicenceInformation = ({ i18n }) => {
  const [isError, setIsError] = useState(false)

  useEffect(() => {
    try {
      addToGoogleDataLayer('fishing-licence-info', 'Renew your Vehicle Permit', i18n.language)
      window.scrollTo(0, 0)
    } catch (e) {
      console.log(e)
    }
  }, [])

  return isError ? <Error /> : <FishingLicenceInformationView setIsError={setIsError} />
}

export default withTranslation('common')(FishingLicenceInformation)
